// src/pages/novoEvento/utils/validators.js
export function validateStep(stepIndex, s) {
    const errors = {};

    const req = (path, msg) => {
        errors[path] = msg;
    };

    if (stepIndex === 0) {
        if (!s.identidade.titulo.trim()) req("identidade.titulo", "Título é obrigatório");
        if (!s.identidade.categoria.trim()) req("identidade.categoria", "Categoria é obrigatória");
        const bannerOk =
            (s.identidade.banner.mode === "url" && !!s.identidade.banner.url.trim()) ||
            (s.identidade.banner.mode === "file" && !!s.identidade.banner.file) ||
            !!s.identidade.banner.previewUrl;
        if (!bannerOk) req("identidade.banner", "Banner é obrigatório (URL ou arquivo)");
    }

    if (stepIndex === 1) {
        if (!s.dataLocal.dataInicio) req("dataLocal.dataInicio", "Data de início é obrigatória");
        if (!s.dataLocal.horaInicio) req("dataLocal.horaInicio", "Hora de início é obrigatória");
        if (!s.dataLocal.local.nome.trim()) req("dataLocal.local.nome", "Nome do local é obrigatório");
        if (!s.dataLocal.local.cidade.trim()) req("dataLocal.local.cidade", "Cidade é obrigatória");
        if (!s.dataLocal.local.estado.trim()) req("dataLocal.local.estado", "Estado é obrigatório");
    }

    if (stepIndex === 2) {
        if (!s.descricao.texto.trim()) req("descricao.texto", "Descrição é obrigatória");
    }

    if (stepIndex === 3) {
        if (!s.ingressos.length) req("ingressos", "Adicione ao menos 1 ingresso");
        s.ingressos.forEach((t, i) => {
            if (!t.nome.trim()) req(`ingressos.${i}.nome`, "Nome do ingresso é obrigatório");
            if (Number(t.preco) < 0) req(`ingressos.${i}.preco`, "Preço inválido");
            if (Number(t.quantidade) <= 0) req(`ingressos.${i}.quantidade`, "Quantidade deve ser maior que 0");
        });
    }

    if (stepIndex === 4) {
        // pontos físicos e comissários são opcionais por enquanto
    }

    if (stepIndex === 5) {
        if (s.regras.politicaReembolso === "personalizada" && !s.regras.reembolsoPersonalizado.trim()) {
            req("regras.reembolsoPersonalizado", "Informe a política personalizada");
        }
    }

    return errors;
}

export function hasErrors(errors) {
    return Object.keys(errors).length > 0;
}
